<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <h1>Создание</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <library-form
              :errors="errors"
              @onSubmit="submit"
            />
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import LibraryForm from '../../../components/library/LibraryForm';
import { Library } from '../../../models/library';
import {Media} from "../../../models/media";

export default {
  name: 'Create',
  components: { LibraryForm },
  data: () => ({
    library_id: null,
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
    page: {
      title: "Библиотека"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Библиотека",
        disabled: true,
        to: '/library'
      },
      {
        text: "Создание",
        disabled: true,
        to: '/library/create'
      },
    ]
  }),
  mounted() {
    if (this.$route.params.library_id) {
      this.library_id = this.$route.params.library_id
    }
  },
  methods: {
    async submit({ form, media, mediaIds, isNeedRedirect }) {
      try {
        this.errors = {};
        const storeData = { ...form };
        if (mediaIds) {
          storeData.mediaIds = mediaIds;
        }
        const library = await Library.$query().store(storeData);
        await Media.$query().store({...media, entity_id: library.$attributes.id});
        await this.$router.push({ name: 'library-edit', params: { id: library.$attributes.id } });
        this.snackbarSuccess = true;

        if (isNeedRedirect) {
          await this.$router.push({name: 'library-index'});
        } else {
          await this.$router.push({name: 'library-edit', params: {id: library.$attributes.id}});
        }
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors
          this.snackbarError = true;
        }
        throw e;
      }
    },
  },
};
</script>
